import { getAxisDrivenSlotColumns, getUniqueColumnsById } from './helpers';
import { addMeasureNameField, addMeasureValueField } from './measure-name-value';
export const SLOT_X_AXIS = 'x-axis';
export const SLOT_Y_AXIS_LINE = 'y-axis-line';
export const SLOT_Y_AXIS_COLUMN = 'y-axis-column';
export const SLOT_SLICE_WITH_COLOR = 'slice-with-color';
export const SLOT_TRELLIS_BY = 'trellis-by';
function lineQueryFromColumns(cols, chartModel, queryParams) {
    const seed = [
        {
            queryColumns: cols,
            queryParams: { size: queryParams.size, offset: 0 },
        },
    ];
    const [withMn] = addMeasureNameField(seed, chartModel);
    const [withMnAndMv] = addMeasureValueField([withMn], chartModel);
    return withMnAndMv;
}
const EMPTY_EXTRAS = {
    lineRoot: null,
    lineRowGrandTotals: [],
    lineRowSubTotals: [],
};
export function buildLineStackedColumnExtras(cartesianRowGrandTotalsQueries, cartesianRowSubTotalsQueries, chartConfig, chartModel, queryParams) {
    const xAxis = getAxisDrivenSlotColumns(chartConfig, SLOT_X_AXIS);
    const lineAxis = getAxisDrivenSlotColumns(chartConfig, SLOT_Y_AXIS_LINE);
    if (!lineAxis.length)
        return EMPTY_EXTRAS;
    const columnAxis = getAxisDrivenSlotColumns(chartConfig, SLOT_Y_AXIS_COLUMN);
    const sliceColor = getAxisDrivenSlotColumns(chartConfig, SLOT_SLICE_WITH_COLOR)[0] ?? null;
    const trellisBy = getAxisDrivenSlotColumns(chartConfig, SLOT_TRELLIS_BY)[0] ?? null;
    const excludeIds = new Set([
        ...columnAxis.map((c) => c.id),
        ...(sliceColor ? [sliceColor.id] : []),
    ]);
    const lineRoot = lineQueryFromColumns(getUniqueColumnsById([
        ...xAxis,
        ...lineAxis,
        ...(trellisBy ? [trellisBy] : []),
    ]), chartModel, queryParams);
    const mirrorAsLine = (existingQuery) => lineQueryFromColumns(getUniqueColumnsById([
        ...existingQuery.queryColumns.filter((c) => !excludeIds.has(c.id)),
        ...lineAxis,
    ]), chartModel, queryParams);
    return {
        lineRoot,
        lineRowGrandTotals: cartesianRowGrandTotalsQueries.map(mirrorAsLine),
        lineRowSubTotals: cartesianRowSubTotalsQueries.map(mirrorAsLine),
    };
}
//# sourceMappingURL=line-stacked-column.js.map